export function getUserPermissions(user) {
  return user?.permissions && typeof user.permissions === "object"
    ? user.permissions
    : {};
}

export function hasPermission(user, key) {
  if (!key) return false;
  const permissions = getUserPermissions(user);
  return Boolean(permissions[key]);
}

export function hasAllPermissions(user, keys = []) {
  if (!Array.isArray(keys) || keys.length === 0) return true;
  return keys.every((key) => hasPermission(user, key));
}

export function hasAnyPermission(user, keys = []) {
  if (!Array.isArray(keys) || keys.length === 0) return true;
  return keys.some((key) => hasPermission(user, key));
}
